import { ApiSchema } from "@api-types";
import { useState } from "react";
import { useSubscription } from "rsm/useSubscription";
import { hasPolicy$ } from "helpers/hasPolicy";

export const useHasPolicyCheck = (callback: () => void, policy: ApiSchema.Policy) => {
  useSubscription(hasPolicy$(policy), (hasPolicy) => hasPolicy && callback(), [callback, policy]);
};
export const useHasPolicy = (policy: ApiSchema.Policy) => {
  const [hasPolicy, setHasPolicy] = useState<boolean | null>(null);
  useSubscription(
    hasPolicy$(policy),
    (hasPolicy) => {
      setHasPolicy(hasPolicy);
    },
    [policy, setHasPolicy],
  );
  return hasPolicy;
};

export const useHasNoPolicyCheck = (callback: () => void, policy: ApiSchema.Policy) => {
  useSubscription(hasPolicy$(policy), (hasPolicy) => !hasPolicy && callback(), [callback, policy]);
};

export const useHasNoPolicy = (policy: ApiSchema.Policy) => {
  const [hasPolicy, setHasPolicy] = useState(false);
  useSubscription(
    hasPolicy$(policy),
    (hasPolicy) => {
      setHasPolicy(!hasPolicy);
    },
    [policy, setHasPolicy],
  );
  return hasPolicy;
};
